import {
  applyPhoneMask,
  getPhoneState,
  normalizePhoneDigits,
} from '@/js/autorization/phone.utils';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#formValidation');
  const phoneInput = document.querySelector('#tel');
  const phoneError = document.querySelector('#tel-err');

  if (!form || !phoneInput) return;

  const lang = document.documentElement.lang || 'uk';
  const isRu = lang.startsWith('ru');

  const messages = {
    format: isRu
      ? 'Введите номер телефона в формате +38(0XX)-XXX-XX-XX'
      : 'Введи номер телефону у форматі +38(0XX)-XXX-XX-XX',
    operator: isRu
      ? 'Введён некорректный код оператора'
      : 'Введено некоректний код оператора',
  };

  const setError = (message = '') => {
    if (!phoneError) return;

    phoneError.textContent = message;

    if (message) {
      phoneInput.classList.add('input--error');
      phoneInput.setAttribute('aria-invalid', 'true');
    } else {
      phoneInput.classList.remove('input--error');
      phoneInput.setAttribute('aria-invalid', 'false');
    }
  };

  const phoneMask = applyPhoneMask(phoneInput);

  const customerPhone = phoneInput.dataset.customerPhone || '';

  if (customerPhone) {
    const digits = normalizePhoneDigits(customerPhone);
    const digits10 = digits.startsWith('38')
      ? digits.slice(2)
      : digits.slice(-10);

    if (digits10.length === 10) {
      phoneMask.unmaskedValue = digits10;
    }
  }

  phoneInput.addEventListener('input', () => {
    setError('');
  });

  form.addEventListener('submit', (e) => {
    const state = getPhoneState(phoneInput.value, phoneMask);

    if (!state.isComplete || !state.formatOk) {
      e.preventDefault();
      setError(messages.format);
      phoneInput.focus();
      return;
    }

    if (!state.operatorOk) {
      e.preventDefault();
      setError(messages.operator);
      phoneInput.focus();
      return;
    }

    setError('');
  });
});
